import { render, staticRenderFns } from "./parallax-scene.vue?vue&type=template&id=0d0c72a3&scoped=true&"
import script from "./parallax-scene.vue?vue&type=script&lang=js&"
export * from "./parallax-scene.vue?vue&type=script&lang=js&"
import style0 from "./parallax-scene.vue?vue&type=style&index=0&id=0d0c72a3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c72a3",
  null
  
)

export default component.exports